import { render, staticRenderFns } from "./ProfileRoute.vue?vue&type=template&id=0f54a08d&scoped=true&"
import script from "./ProfileRoute.vue?vue&type=script&lang=js&"
export * from "./ProfileRoute.vue?vue&type=script&lang=js&"
import style0 from "./ProfileRoute.vue?vue&type=style&index=0&id=0f54a08d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f54a08d",
  null
  
)

export default component.exports